"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.key = void 0;
var key = exports.key = {
  COMPONENTS: 'Components',
  URL: 'currentURL',
  STATUS_REFRESH: 'hasRefreshedWithoutClose',
  STATUS_OPEN: 'isModalOpen'
};